import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getHistoryDetailStart,
  getHistoryDetailSuccess,
  getHistoryDetailFailed,
} from "../redux/getHistoryDetail";

import { getHistoryDetailApi } from "core/http/service/personnelInformation";

function* getHistoryDetailWork(
  action: ReturnType<typeof getHistoryDetailStart>
) {
  try {
    const res = yield call(getHistoryDetailApi, action.payload);

    yield put({
      type: getHistoryDetailSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getHistoryDetailFailed.type,
    });
  }
}

function* watchGetHistoryDetail() {
  yield takeLatest(getHistoryDetailStart.type, getHistoryDetailWork);
}

export default function* getHistoryDetailSaga() {
  yield all([watchGetHistoryDetail()]);
}
